import React from 'react';

const Term = () => {
    return (
        <div className="bg-white">
            {/* Banner Section */}
            <div className="bg-brand-orange py-16 px-4 text-center">
                <div className="max-w-4xl mx-auto">
                    <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">
                        Terms & conditions
                    </h2>
                    <p className="text-white text-lg opacity-90 leading-relaxed max-w-2xl mx-auto">
                        Please read these terms carefully before using our platform.
                    </p>
                </div>
            </div>

            <div className="container mx-auto px-4 py-16 max-w-4xl">
                <div className="prose max-w-none text-gray-600 leading-relaxed">
                    <div className="mb-10">
                        <h2 className="text-3xl font-bold text-gray-800 mb-4">Terms & Conditions</h2>
                        <p>Welcome to Getfast Education. By accessing and using our platform, you agree to comply with the following Terms & Conditions. Please read them carefully before proceeding.</p>
                    </div>

                    <div className="mb-8">
                        <h3 className="text-2xl font-bold text-gray-800 mb-2">1. General Information</h3>
                        <p>Getfast Education provides unbiased, detailed, and accurate information about online universities and courses. While we strive to ensure the accuracy of the information presented, we do not guarantee the completeness or absolute correctness of all details. Universities may update their courses, fees, or admission criteria without prior notice.</p>
                    </div>

                    <div className="mb-8">
                        <h3 className="text-2xl font-bold text-gray-800 mb-2">User Responsibilities</h3>
                        <p>Users must verify all information from the respective university’s official website before making enrollment decisions. Getfast Education is not responsible for any discrepancies between the information on our platform and university updates. Misuse of the website, including unauthorized data extraction or content reproduction, is strictly prohibited.</p>
                    </div>

                    <div className="mb-8">
                        <h3 className="text-2xl font-bold text-gray-800 mb-2">Admission & Fees</h3>
                        <p>Admission to universities listed on Getfast Education is subject to eligibility criteria set by respective institutions. Fee structures, payment options, and scholarships vary across universities. We do not facilitate direct admissions or process payments on behalf of any institution. Users are advised to check the latest admission details, entrance requirements, and payment methods directly with the university.</p>
                    </div>

                    <div className="mb-8">
                        <h3 className="text-2xl font-bold text-gray-800 mb-2">Third-Party Links</h3>
                        <p>Our platform may include links to third-party websites, including university portals and official admission pages. Getfast Education does not control or take responsibility for the content, policies, or services provided by external websites.</p>
                    </div>

                    <div className="mb-8">
                        <h3 className="text-2xl font-bold text-gray-800 mb-2">Modifications & Updates</h3>
                        <p>Getfast Education reserves the right to update or modify these Terms & Conditions at any time without prior notice. Users are encouraged to review this page periodically for the latest updates. By using Getfast Education, you acknowledge that you have read and understood these terms and agree to abide by them. For any queries, feel free to contact us.</p>
                    </div>

                    <div className="mb-8">
                        <h3 className="text-2xl font-bold text-gray-800 mb-2">Limitation of Liability</h3>
                        <p>Getfast Education serves as an information aggregator and does not guarantee admission or placement at any university. We are not liable for any decisions made based on the information provided on our platform.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Term;
